import { render, staticRenderFns } from "./reports-editor.pug?vue&type=template&id=0a11acd9&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./reports-editor.scss?vue&type=style&index=0&id=0a11acd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11acd9",
  null
  
)

export default component.exports